import REST from '../rest';

const ENDPOINT = 'api/v1/feedbacks/answer_identifiers';
const DEFAULT_PAGE_SIZE = 200;

const queryParams = (campaignIds, query) => ({
  q: query,
  filter: {
    campaign_id: campaignIds,
  },
  page: {
    size: DEFAULT_PAGE_SIZE,
  },
});

export const load = (campaignIds, query = null) => (
  REST.get(ENDPOINT, '', queryParams(campaignIds, query))
);

export default load;
